export enum ProjectLearnerStatus {
  Enrolled,
  Absorbed,
  Completed,
  Terminated,
  DropOff,
}
